import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { type GetAllBoostPoolApyQuery } from '@/shared/graphql/generated/lp/graphql';
import { getAllBoostPoolApyQuery } from '@/shared/graphql/lp/boost';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export const useBoostPoolApy = (asset?: ChainflipAsset, feeTierPips?: number) => {
  const { data: apyData, isLoading } = useGqlQuery(getAllBoostPoolApyQuery, {
    variables: {
      asset,
      feeTierPips,
    },
    select: (queryResult: GetAllBoostPoolApyQuery) =>
      queryResult.allBoostPools?.nodes.map((pool) => ({
        asset: pool.asset,
        feeTierPips: pool.feeTierPips,
        apy: Number(pool.apys.nodes[0].projectedApy72H ?? 0),
      })),
    context: { clientName: 'lpProcessor' },
  });

  return {
    apys: apyData,
    isLoading,
  };
};
